module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_PT-b791e34cdb4982227e397445b0e8a1f1.svg";